import { render, staticRenderFns } from "./directoryDetail.vue?vue&type=template&id=2f879eda&scoped=true"
import script from "./directoryDetail.vue?vue&type=script&lang=js"
export * from "./directoryDetail.vue?vue&type=script&lang=js"
import style0 from "./directoryDetail.vue?vue&type=style&index=0&id=2f879eda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f879eda",
  null
  
)

export default component.exports